import React from 'react';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { useIntl } from 'react-intl';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import useCurrentBuilderPage from '../../../../../admin/hooks/useCurrentBuilderPage';
import widgetDecorator from './widget';

export const GET_FACILITIES = gql`
  query GetFacilities($live: Boolean!, $locale: String!) {
    facilities(filter: { live: $live, locale: $locale }) {
      edges {
        node {
          id
          address {
            address1
            address2
            city
            country
            longitude
            latitude
            postal
            state
          }
          currencySymbol
          linkOutUrl
          minimumUnitPrice
          displayName
          pagePaths(filter: { live: $live, locale: $locale }) {
            path
            locale
          }
          phone
          primaryImageMediumId
          applicableFeesEnabled
          rating
          settings {
            businessAddressDescription
            tagline
          }
        }
      }
    }
  }
`;

export default (details, { resolve = null, ...options } = {}) => {
  const createHOC = (Component) => {
    const WidgetComponent = widgetDecorator(details, { ...options, resolve })(Component);

    const FacilitiesWidget = (props) => {
      const { locale: builderPageLocale } = useCurrentBuilderPage();
      const { locale: intlProviderLocale } = useIntl();
      const locale = builderPageLocale || intlProviderLocale;
      const { ...rest } = props;

      const { data } = useQuery(
        GET_FACILITIES, { variables: { live: true, locale } },
      );

      const facilities = data ? data.facilities.edges.map(({ node }) => node) : [];

      const newProps = {
        facilities,
        locale,
        ...rest,
      };

      return <WidgetComponent {...newProps} />;
    };

    FacilitiesWidget.displayName = `FacilitiesWidget(${WidgetComponent.displayName})`;

    return connect()(hoistNonReactStatic(FacilitiesWidget, WidgetComponent));
  };

  return createHOC;
};
